import Vue from 'vue'
// import Navigation from '@/components/Navigation.vue'
// import Header from "@/components/Header.vue"
// import Notification from "@/components/Notification.vue"
// import BetweenHeader from "@/components/BetweenHeader.vue"
// import DataList from "@/components/datalist/DataList.vue"
// import DataListSlot from "@/components/datalist/DatalistSlotSupport.vue"
import Icon from "@/components/icon/Icon.vue"
// import CurrencyJustified from "@/components/CurrencyJustified.vue"
// import Empty from "@/components/EmptyComponent.vue"
// import Status from "@/components/Status.vue"
// import IaoList from "@/components/iao-list/IaoList.vue"
// import IaoImage from "@/components/iao-image/Image.vue"
// import Collective from "@/components/collective/Collective.vue"

// Vue.component('Mis-Navigation', Navigation);
// Vue.component('Mis-Header', Header);
// Vue.component('Mis-Notification', Notification);
// Vue.component('Mis-BetweenHeader', BetweenHeader);
// Vue.component('DataList', DataList);
// Vue.component('DataListSlot', DataListSlot);
Vue.component('Icon', Icon);
// Vue.component('CurrencyJustified', CurrencyJustified);
// Vue.component('Empty', Empty);
// Vue.component('Status', Status);
// Vue.component('Mis-Image', IaoImage);
// Vue.component('Collective', Collective);

// Under Construction
// Vue.component('IaoList', IaoList);